<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-currency-field
          v-model="forminvoice.exchange_rate"
          prefix="Rp."
          type="number"
          dense
          outlined
          placeholder="Exchange"
          label="Exchange Rate"
        />
        <v-text-field
          v-model="forminvoice.tour_code"
          disabled
          dense
          outlined
          placeholder="Id Tour"
          label="Id Tour"
        />
        <v-text-field
          v-model="forminvoice.guest_name"
          dense
          outlined
          placeholder="Guest Name"
          label="Guest Name"
        />
        <v-row>
          <v-col>
            <v-text-field
              v-model="forminvoice.total_adult"
              dense
              hide-details=""
              type="number"
              outlined
              placeholder="Total Adult"
              label="Total Adult"
              @change="AddTotalPax()"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="forminvoice.total_cnb"
              hide-details=""
              dense
              type="number"
              outlined
              placeholder="Total CNB"
              label="Total CNB"
              @change="AddTotalPax()"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="forminvoice.total_cwb"
              dense
              type="number"
              hide-details=""
              outlined
              placeholder="Total CWB"
              label="Total CWB"
              @change="AddTotalPax()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="forminvoice.travel_date"
              persistent
              width="290px"
              @keydown="MakeCode()"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="forminvoice.travel_date"
                  label="Travel Date"
                  dense
                  outlined
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="forminvoice.travel_date"
                :min="new Date().toISOString().substr(0, 10)"
                scrollable
                @change="MakeCode()"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="modal = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(forminvoice.travel_date)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="forminvoice.total_day"
              dense
              outlined
              placeholder="Total Day"
              label="Total Day"
              @change="CountDate()"
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="forminvoice.end_travel_date"
              dense
              disabled
              outlined
              placeholder="End Travel Date"
              label="End Travel Date"
            />
          </v-col>
        </v-row>
        <v-autocomplete
          v-model="forminvoice.region"
          :items="regions"
          item-text="region_name"
          item-value="id_region"
          dense
          outlined
          placeholder="Region"
          label="Region"
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="forminvoice.file_handler"
          dense
          readonly
          outlined
          placeholder="File Handler"
          label="File Handler"
        />

        <v-autocomplete
          v-model="select"
          :items="agents"
          :loading="isLoading"
          :search-input.sync="search"
          cache-items
          clearable
          hide-selected
          label="Search Data Agent"
          dense
          outlined
          return-object
          item-text="agent_name"
        />
        <v-text-field
          v-model="forminvoice.agent_code"
          readonly
          dense
          outlined
          placeholder="Agent Code"
          label="Agent Code"
        />
        <v-text-field
          v-model="forminvoice.phone"
          readonly
          dense
          outlined
          placeholder="Phone"
          label="Phone"
        />
        <v-textarea
          rows="4"
          v-model="forminvoice.note_tour"
          dense
          outlined
          placeholder="Note"
          label="Note"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data() {
    return {
      select: null,
      modal: false,
      agents: [],
      search: null,
      isLoading: false,
      forminvoice: {
        note_tour: '',
        region: '',
        id_tour: '',
        tour_code: '',
        newmarkup: 0,
        exchange_rate: 0,
        total_perpax_adult: 0,
        total_perpax_cnb: 0,
        total_perpax_cwb: 0,
        grandtotal: 0,
        guest_name: '',
        travel_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        total_day: 0,
        end_travel_date: '',
        total_pax: 0,
        total_adult: 0,
        total_child: 0,
        total_cwb: 0,
        total_cnb: 0,
        file_handler: this.$store.state.user.name,
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
      },
      regions: [],
    }
  },
  watch: {
    search(val) {
      // eslint-disable-next-line no-unused-expressions
      val && val !== this.select && this.querySelections(val)
      if (this.select !== null) {
        this.forminvoice.agent_code = this.select.agent_code
        this.forminvoice.agent_name = this.select.agent_name
        this.forminvoice.email = this.select.email
        this.forminvoice.id_agent = this.select.id_agent
        this.forminvoice.phone = this.select.phone
      }
    },

  },
  mounted() {
    this.initializeregion()
    this.MakeCode()
  },
  created() {
    if (this.$route.query.id_tour) {
      this.getDataEditTour()
    }
  },
  methods: {
    getDataEditTour() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getDataEditTour', { id_tour: this.$route.query.id_tour }).then(response => {
        this.select = response.data.data.agent_name
        this.forminvoice = response.data.data
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.AddTotalPax()
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    initializeregion() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Region').then(response => {
        this.regions = response.data.data
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    CountDate() {
      // eslint-disable-next-line radix
      const total = (parseInt(this.forminvoice.total_day) - parseInt(1))
      const date = moment(this.forminvoice.travel_date, 'YYYY-MM-DD').add(total, 'days').format('YYYY-MM-DD')
      this.forminvoice.end_travel_date = date
    },
    MakeCode() {
      this.forminvoice.tour_code = `BLMQF${moment(this.forminvoice.travel_date, 'YYYY-MM-DD').format('YYMM')}XX`
    },
    AddTotalPax() {
      // eslint-disable-next-line radix
      // eslint-disable-next-line radix
      this.forminvoice.total_pax = parseInt(this.forminvoice.total_adult) + parseInt(this.forminvoice.total_cnb) + parseInt(this.forminvoice.total_cwb)
      // eslint-disable-next-line radix
      this.forminvoice.total_child = parseInt(this.forminvoice.total_cnb) + parseInt(this.forminvoice.total_cwb)
    },
    querySelections() {
      this.isLoading = true

      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Agent').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.agents = response.data.data
        this.isLoading = false
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },

  },
}

</script>
